import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canCreateCountry } from "./permissions";
import { useRoles } from "./useRoles";

type Props = {
  children: ReactNode;
};

export const RequireCreateCountry = ({ children }: Props) => {
  const roles = useRoles();

  if (!canCreateCountry(roles)) {
    return <Navigate to="/countries" replace />;
  }

  return children;
};
